import { useState, useEffect } from 'react';
import { flushSync } from "react-dom";
import { Row, Col, Card, CardBody, CardHeader, Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Input, Form, FormGroup, Spinner, Badge, Table } from 'reactstrap';
import toast, { Toaster } from 'react-hot-toast';
import { FaPlus, FaEdit } from 'react-icons/fa';
import axios from 'axios';
import Select, { components } from 'react-select';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import '../Ghg/Ghg.css';
import Photos from '../Uploads/Photos';
import PhotosWithoutId from '../Uploads/PhotosWithoutId';
import PhotosWithDetails from '../Uploads/PhotosWithDetails';
import uuid from 'react-uuid';
import moment from "moment";
import ActivityRiskFromSummary from './ActivityRiskFromSummary';
import './Action.css';
import Draggable, { DraggableCore } from 'react-draggable';
import useLocalStorage from "../Utilities/Hooks/useLocalStorage";
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const createGroup = (groupName, options, setGmpValue) => {
    return {
        label: (() => {
            return (
                <div
                    onClick={() =>
                        setGmpValue(value =>
                            value.concat(options.filter(grpOpt => !value.includes(grpOpt)))
                        )
                    }
                >
                    {groupName}
                </div>
            );
        })(),
        options: options
    };
};

const Option = (props) => {//Select Significant Sites and Species
    return (
        <div>
            <components.Option {...props}>
                {
                    props.selectProps.placeholder == 'Select Contaminants' && <div>
                        <input
                            type="checkbox"
                            checked={props.isSelected}
                            onChange={() => null}
                        />{" "}
                        <label>{props.label}</label>
                        {props.data.isCatchmentContaminant && <Badge style={{ marginLeft: '10px' }} color="warning">CP</Badge>}
                    </div>
                }
                {
                    props.selectProps.placeholder == 'Select Significant Sites and Species' && <div>
                        <input
                            type="checkbox"
                            checked={props.isSelected}
                            onChange={() => null}
                        />{" "}
                        <label>{props.label} ({props.data.itemTypeName})</label>
                    </div>
                }
                {
                    props.selectProps.placeholder == 'Select Inherent Risks' && <div>
                        <input
                            type="checkbox"
                            checked={props.isSelected}
                            onChange={() => null}
                        />{" "}
                        <label>{props.label}</label>
                    </div>
                }
                {
                    (props.selectProps.placeholder == 'Select Management Areas / Objective(s)' || props.selectProps.placeholder == 'Select Target(s)'
                        || props.selectProps.placeholder == 'Select Area / Category(s)' || props.selectProps.placeholder == 'Select GMP(s)') && <div>
                        <input
                            type="checkbox"
                            checked={props.isSelected}
                            onChange={() => null}
                        />{" "}
                        <label>{props.label}</label>
                    </div>
                }
            </components.Option>
        </div>
    );
};

const ActionFromSummary = ({ refreshToken,width, height, refreshRiskSummary, actionId, itemTypeSelect, showActionPopupModal, pageDisabled, itemTypeDisabled, itemId, itemName, sectionName, itemTypeId, redirectPage, handleActionClose, sectionId, wholeFarmAction, itemList, selectedLUId, isGHGNutrient, selectedRiskId }) => {
    const [roleName, setRoleName] = useState(localStorage.getItem("roleName")); const [showFuturePossibleActionOnly, setShowFuturePossibleActionOnly] = useState(false);
    //const isCreateNewAction = localStorage.getItem("isCreateNewAction");
    const [actionWholeData, setActionWholeData] = useState([]); const [imageUploadList, setImageUploadList] = useState([]);
    const [evidenceRecordList, setEvidenceRecordList] = useState([]); const [farmRoleName, setFarmRoleName] = useLocalStorage('farmRoleName', null);
    //const isSubmitEvidenceCloseAction = localStorage.getItem("isSubmitEvidenceCloseAction");
    const [activityRiskIds, setActivityRiskIds] = useState(''); const [formErrorList, setFormErrorList] = useState([]);
    const [ghgNutrient, setGHGNutrient] = useState(isGHGNutrient == undefined ? false : isGHGNutrient); const [pagesList, setPagesList] = useState([]);
    const [loading, setLoading] = useState(true); const [activityRiskId, setActivityRiskId] = useState(0); const [activityRisk, setActivityRisk] = useState('');
    const [lmuId, setLMUId] = useState(0); const [showActivityRisk, setShowActivityRisk] = useState(false); const [activityRiskIdList, setActivityRiskIdList] = useState([]);
    const [inherentRisksObj, setInherentRisksObj] = useState({ inherentRisks: [], inherentRisksList: [] })
    const [significantSpeciesObj, setSignificantSpeciesObj] = useState({ significantSpecies: [], significantSpeciesList: [] })
    const [contaminantObj, setContaminantObj] = useState({ contaminants: [], contaminantList: [] })
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId")); const [actionPopupName, setActionPopupName] = useState(actionId == 0 ? 'Add Action' : 'Edit Action');
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [user, setUser] = useState(JSON.parse(localStorage.getItem("auth")));
    const [formErrors, setFormErrors] = useState({});
    const [actionTypes, setActionTypes] = useState([]);
    const [submitDate, setSubmitDate] = useState(null);
    const [tempId, setTempId] = useState(actionId == undefined ? 0 : actionId);
    const [activityRiskModel, setActivityRiskModel] = useState({});
    const [farmAPTActionList, setFarmAPTActionList] = useState([]);
    const [activityRiskPopup, setActivityRiskPopup] = useState({
        activityId: 0, activityRiskId: 0, activityRiskIds: '', activityRiskText: '', recommendedActionId: 0, recommendedActionText: '', recommendedActionDescription: '', showActivityRisk: false, luId: '',
        enterpriseTypeId: 0, naActivityRisk: false, recommendedActionList: []
    });
    const [actionPopup, setActionPopup] = useState({
        totalActions: 0, currentAction: 0, riskDescription: '',
        type: itemTypeId, name: itemName, id: actionId, actionType: 0, title: '', description: '', itemId: itemId,
        regulatoryRequirement: '', catchmentPriority: '', significantEnvironmentBenfit: '', priority: '', estimatedCost: '', financialNotes: '',
        pastTargetOutlineReasons: '', closeOutDetail: '', isCloseout: false, createdByName: '', createdDate: null, activityRiskId: 0, activityRiskIds: '', luId: 0, farmEnterpriseId: 0, existingAction: false,
        category: '', recommendedActionId: 0, regulatoryRequirementDescription: '', futurePossibleActionOnly: '',
        onGoingFrom: null, informationAboutImplementationTiming: '', doesThisActionRelateToNewPhysicalWorks: false, whatRegulatoryRequirementIsBeingMetWithThisAction: '', pageId: sectionId,
        managementAreaObjective: [], managementAreaTarget: [], gmpCategory: [], gmp: []
    }); const [savingAction, setSavingAction] = useState(''); const [savingActionCloseSave, setSavingActionCloseSave] = useState(false);
    let options = [];
    const [gmpOptions, setGmpOptions] = useState([]);
    const [gmpValue, setGmpValue] = useState([]);
    const [showActionPopup, setShowActionPopup] = useState(false);
    const [contaminantList, setContaminantList] = useState([]);
    const [contaminantSelectedValues, setContaminantSelectedValues] = useState('');
    const [contaminantListSelectedValues, setContaminantListSelectedValues] = useState([]);
    const [actionDueDate, setActionDueDate] = useState(null);
    const [onGoingFrom, setOnGoingFrom] = useState(null);
    const [uploadReqPopup, setUploadReqPopup] = useState({ showUploadReqPopup: false });
    const [actionCreatedOn, setActionCreatedOn] = useState('');
    const [isOngoingAction, setIsOngoingAction] = useState(false);
    const [isFarmOperational, setIsFarmOperational] = useState(false);
    const [actionDeletePopup, setActionDeletePopup] = useState({ showActionDeletePopup: false, id: 0 });
    const [wholeFarmInherentRisksList, setWholeFarmInherentRisksList] = useState([]);
    const [isDairyActivity, setIsDairyActivity] = useState(false);
    const [showPastTargetOutlineReasons, setShowPastTargetOutlineReasons] = useState(false);
    const [managementAreaObjectiveList, setManagementAreaObjectiveList] = useState([]); const [managementAreaTargetList, setManagementAreaTargetList] = useState([]);
    const [tempManagementAreaTargetList, setTempManagementAreaTargetList] = useState([]);
    const [gmpCategoryList, setGMPCategoryList] = useState([]); const [gmpList, setGMPList] = useState([]); const [tempGMPList, setTempGMPList] = useState([]);
    const [showEnvironmentCanterbury, setShowEnvironmentCanterbury] = useState(false); const [subRegion, setSubRegion] = useState('');
    const OnPageload = async (e) => {
        try {
            actionId = actionId == undefined ? 0 : actionId;
            const response = await apiGet(
                '/api/action/GetActionForSummary/', {
                params: { Id: actionId, sectionId: sectionId, farmId: farmId, lmuId: (wholeFarmAction || ghgNutrient) ? selectedLUId.toString() : itemList.filter(x => x.itemId == itemId)[0].lmuIds, ItemAction: (wholeFarmAction || isGHGNutrient) ? false : true }
            }
            );
            if (response.data.status) {
                setActionWholeData(response.data.content);
                setPagesList(response.data.content.pages);
                setActionTypes(response.data.content.actionTypes);
                setContaminantList(response.data.content.contaminantList);
                setContaminantListSelectedValues(response.data.content.contaminants);
                setActivityRiskModel(response.data.content.activityRiskModel);
                //if (response.data.content.activityRiskModel.enterpriseList.filter(x => x.label.includes('Dairy')).length > 0) {
                //    setIsDairyActivity(true);
                //}
                setFarmAPTActionList(response.data.content.farmAPTActionList);
                setShowActivityRisk(true);
                //setWholeFarmInherentRisksList(response.data.content.wholeFarmInherentRisksList);
                for (var i = 0; i < response.data.content.goodFarmingPracticeGroups.length; i++) {
                    var goodFarmingPractices = response.data.content.goodFarmingPracticeList.filter(x => x.group1 == response.data.content.goodFarmingPracticeGroups[i].name);
                    options.push(createGroup(response.data.content.goodFarmingPracticeGroups[i].name, goodFarmingPractices, setGmpValue));
                }
                setGmpOptions(options);
                setManagementAreaObjectiveList(response.data.content.managementAreaObjectiveList);
                setTempManagementAreaTargetList(response.data.content.managementAreaTargetList);
                setGMPCategoryList(response.data.content.gmpCategoryList);
                setTempGMPList(response.data.content.gmpList);
                setShowEnvironmentCanterbury(response.data.content.showEnvironmentCanterbury);
                setSubRegion(response.data.content.subRegion);
                if (actionId != 0) {
                    var managementAreaObjective = []; var managementAreaTarget = []; var gmpCategory = []; var gmp = [];
                    var selectedmanagementAreaObjective = response.data.content.managementAreaObjective != null ? response.data.content.managementAreaObjective.split(',') : [];
                    var selectedmanagementAreaTarget = response.data.content.managementAreaTarget != null ? response.data.content.managementAreaTarget.split(',') : [];
                    var selectedgmpCategory = response.data.content.gmpCategory != null ? response.data.content.gmpCategory.split(',') : [];
                    var selectedgmp = response.data.content.gmp != null ? response.data.content.gmp.split(',') : [];
                    selectedmanagementAreaObjective.map((item) => {
                        var managementAreaObjectiveObj = response.data.content.managementAreaObjectiveList.filter(x => x.value == parseInt(item));
                        if (managementAreaObjectiveObj != undefined && managementAreaObjectiveObj.length > 0) {
                            managementAreaObjective.push(managementAreaObjectiveObj[0]);
                        }
                    });
                    selectedmanagementAreaTarget.map((item) => {
                        var managementAreaTargetObj = response.data.content.managementAreaTargetList.filter(x => x.value == parseInt(item));
                        if (managementAreaTargetObj != undefined && managementAreaTargetObj.length > 0) {
                            managementAreaTarget.push(managementAreaTargetObj[0]);
                        }

                    });
                    selectedgmpCategory.map((item) => {
                        var gmpCategoryObj = response.data.content.gmpCategoryList.filter(x => x.value == parseInt(item));
                        if (gmpCategoryObj != undefined && gmpCategoryObj.length > 0) {
                            gmpCategory.push(gmpCategoryObj[0]);
                        }

                    });
                    selectedgmp.map((item) => {
                        var gmpObj = response.data.content.gmpList.filter(x => x.value == parseInt(item));
                        if (gmpObj != undefined && gmpObj.length > 0) {
                            gmp.push(gmpObj[0]);
                        }
                    });
                    let myArrayFiltered = [];
                    myArrayFiltered = response.data.content.managementAreaTargetList.filter((el) => {
                        return managementAreaObjective.some((f) => {
                            return f.value === el.parentId;
                        });
                    });
                    setManagementAreaTargetList(myArrayFiltered);
                    myArrayFiltered = [];
                    myArrayFiltered = response.data.content.gmpList.filter((el) => {
                        return gmpCategory.some((f) => {
                            return f.value === el.parentId;
                        });
                    });
                    setGMPList(myArrayFiltered);

                    if (wholeFarmAction) {
                        setActionPopup({
                            ...actionPopup, riskDescription: response.data.content.riskDescription, id: response.data.content.id, type: response.data.content.ghgItemTypeId, name: itemName, actionType: response.data.content.actionType, title: response.data.content.title,
                            description: response.data.content.description, regulatoryRequirement: response.data.content.regulatoryRequirement, catchmentPriority: response.data.content.catchmentPriority,
                            significantEnvironmentBenfit: response.data.content.significantEnvironmentBenfit, priority: response.data.content.priority, estimatedCost: response.data.content.estimatedCost,
                            financialNotes: response.data.content.financialNotes, pastTargetOutlineReasons: response.data.content.pastTargetOutlineReasons, closeOutDetail: response.data.content.closeOutDetail
                            , isCloseout: response.data.content.isCloseout, itemId: itemId, createdByName: response.data.content.createdByName, actualCost: response.data.content.actualCost,
                            actualCostNotes: response.data.content.actualCostNotes, createdDate: response.data.content.createdOn, activityRiskId: response.data.content.activityRiskId, activityRiskIds: response.data.content.activityRiskIds, luId: response.data.content.luId, farmEnterpriseId: response.data.content.farmEnterpriseId
                            , existingAction: response.data.content.existingAction, category: response.data.content.category, recommendedActionId: response.data.content.recommendedActionId,
                            regulatoryRequirementDescription: response.data.content.regulatoryRequirementDescription, futurePossibleActionOnly: 
                                response.data.content.futurePossibleActionOnly == null ? '' : (response.data.content.futurePossibleActionOnly == true ? 'Yes' : 'No')
                            ,
                            doesThisActionRelateToNewPhysicalWorks: response.data.content.doesThisActionRelateToNewPhysicalWorks, informationAboutImplementationTiming: response.data.content.informationAboutImplementationTiming,
                            whatRegulatoryRequirementIsBeingMetWithThisAction: response.data.content.whatRegulatoryRequirementIsBeingMetWithThisAction, onGoingFrom: response.data.content.onGoingFrom,
                            managementAreaObjective: managementAreaObjective, managementAreaTarget: managementAreaTarget, gmpCategory: gmpCategory, gmp: gmp
                        });
                    }
                    else {
                        setActionPopup({
                            ...actionPopup, riskDescription: response.data.content.riskDescription, id: response.data.content.id, type: response.data.content.ghgItemTypeId, name: itemName, actionType: response.data.content.actionType, title: response.data.content.title,
                            description: response.data.content.description, regulatoryRequirement: response.data.content.regulatoryRequirement, catchmentPriority: response.data.content.catchmentPriority,
                            significantEnvironmentBenfit: response.data.content.significantEnvironmentBenfit, priority: response.data.content.priority, estimatedCost: response.data.content.estimatedCost,
                            financialNotes: response.data.content.financialNotes, pastTargetOutlineReasons: response.data.content.pastTargetOutlineReasons, closeOutDetail: response.data.content.closeOutDetail
                            , isCloseout: response.data.content.isCloseout, itemId: itemId, createdByName: response.data.content.createdByName, actualCost: response.data.content.actualCost,
                            actualCostNotes: response.data.content.actualCostNotes, createdDate: response.data.content.createdOn, activityRiskId: response.data.content.activityRiskId, activityRiskIds: response.data.content.activityRiskIds, farmEnterpriseId: response.data.content.farmEnterpriseId
                            , existingAction: response.data.content.existingAction, category: response.data.content.category, luId: response.data.content.luId, recommendedActionId: response.data.content.recommendedActionId,
                            regulatoryRequirementDescription: response.data.content.regulatoryRequirementDescription, futurePossibleActionOnly: 
                                response.data.content.futurePossibleActionOnly == null ? '' : (response.data.content.futurePossibleActionOnly == true ? 'Yes' : 'No')
                            ,
                            doesThisActionRelateToNewPhysicalWorks: response.data.content.doesThisActionRelateToNewPhysicalWorks, informationAboutImplementationTiming: response.data.content.informationAboutImplementationTiming,
                            whatRegulatoryRequirementIsBeingMetWithThisAction: response.data.content.whatRegulatoryRequirementIsBeingMetWithThisAction, onGoingFrom: response.data.content.onGoingFrom,
                            managementAreaObjective: managementAreaObjective, managementAreaTarget: managementAreaTarget, gmpCategory: gmpCategory, gmp: gmp
                        });
                    }
                    if (response.data.content.category == 'S' || response.data.content.category == 'C') {
                        setShowFuturePossibleActionOnly(true);
                    }

                    var activityRiskIds = [];
                    var activityRiskLabel = '';
                    if (response.data.content.activityRiskIds != undefined && response.data.content.activityRiskIds != null && response.data.content.activityRiskIds != '') {
                        var activityRiskIdList = response.data.content.activityRiskIds.split(',');
                        for (var i = 0; i < activityRiskIdList.length; i++) {
                            activityRiskIds.push(parseInt(activityRiskIdList[i]));
                            var activityRiskObj = response.data.content.activityRiskModel.activityRiskList.filter(x => x.value == parseInt(activityRiskIdList[i]));
                            if (activityRiskObj[0] != undefined && activityRiskObj[0] != null) {
                                if (activityRiskLabel == '') {
                                    activityRiskLabel = activityRiskObj[0].label;
                                }
                                else {
                                    activityRiskLabel += ', ' + activityRiskObj[0].label;
                                }
                            }
                        }
                    }
                    if (activityRiskIds.length > 0) {
                        setActivityRiskIdList(activityRiskIds);
                        var activityRiskObj = response.data.content.activityRiskModel.activityRiskList.filter(x => x.value == activityRiskIds[0])[0];
                        if (activityRiskObj != undefined) {
                            setActivityRiskId(response.data.content.activityRiskId);
                            setActivityRisk(activityRiskLabel);
                            setActivityRiskPopup({ ...activityRiskPopup, activityRiskId: response.data.content.activityRiskId, luId: response.data.content.luId, activityRiskIds: response.data.content.activityRiskIds })
                        }
                    }

                    setActionDueDate(getDateFromString(moment(response.data.content.dueDate).format("DD/MM/YYYY")));
                    if (response.data.content.submitDate != null) {
                        setSubmitDate(getDateFromString(moment(response.data.content.submitDate).format("DD/MM/YYYY")));
                    }
                    if (response.data.content.onGoingFrom != null) {
                        setOnGoingFrom(getDateFromString(moment(response.data.content.onGoingFrom).format("DD/MM/YYYY")));
                    }
                    setGmpValue(response.data.content.goodFarmingPractices);
                    setActionCreatedOn(moment(response.data.content.createdOn).format("DD/MM/YYYY"));
                    if (response.data.content.actionType == 46) {
                        setIsOngoingAction(true);
                    }
                    else {
                        setIsOngoingAction(false);
                    }
                }
                else {
                    setActionPopup({
                        ...actionPopup, riskDescription: '', type: sectionName == "GHG" ? itemTypeSelect[0].id : itemTypeId, name: itemName, id: actionId, actionType: parseInt(response.data.content.actionTypes[0].id), title: '', description: '', actionType: 0,
                        regulatoryRequirement: 'Yes', catchmentPriority: 'Yes', significantEnvironmentBenfit: 'Yes', priority: '1', estimatedCost: '', financialNotes: '', closeOutDetail: ''
                        , isCloseout: false, itemId: itemId, createdByName: user.fullName, actualCost: '', actualCostNotes: '', existingAction: false, category: '', regulatoryRequirementDescription: '',
                        futurePossibleActionOnly: '',activityRiskId: selectedRiskId, luId: selectedLUId.toString()
                    });
                    var activityRiskObj = response.data.content.activityRiskModel.activityRiskList.filter(x => x.value == selectedRiskId)[0];
                    if (activityRiskObj != undefined) {
                        setActivityRiskId(selectedRiskId);
                        setActivityRisk(activityRiskObj.label);
                        setActivityRiskPopup({ ...activityRiskPopup, activityRiskId: selectedRiskId, luId: selectedLUId.toString(), showActivityRisk: true })
                    }
                    setActionCreatedOn(getParsedDate1(new Date()));
                }

                setShowActionPopup(showActionPopupModal);
                setIsFarmOperational(response.data.content.isOperational);
                if (document.getElementById('btnActionSave') != undefined) {
                    document.getElementById('btnActionSave').style.display = "block";
                }
                if (document.getElementById('btnActionCloseSave') != undefined) {
                    document.getElementById('btnActionCloseSave').style.display = "block";
                }
            }

        } catch (err) {
            console.log(err);
        }
        setLoading(false);
    }

    const handleContaminantsChange = (e) => {
        setContaminantListSelectedValues('');
        var contaminantSelectedValues = '';
        setContaminantListSelectedValues(e);
        e.forEach(function (element) {
            if (contaminantSelectedValues == '') {
                contaminantSelectedValues = element.value;
            }
            else {
                contaminantSelectedValues = contaminantSelectedValues + ',' + element.value;
            }
        });
        setContaminantSelectedValues(contaminantSelectedValues);
    }

    useEffect(() => {
        setLoading(true);
        if (wholeFarmAction || ghgNutrient) {
            setLMUId(selectedLUId);
        }
        else {
            setLMUId(itemList.filter(x => x.itemId == itemId)[0].lmuIds);
        }
        OnPageload();
    }, [])

    function handleInputChange(event) {
        const { name, value, checked, type } = event.target;
        if (name == 'actionType') {
            if (value == '45') {
                setIsOngoingAction(false);
                setOnGoingFrom(null);
                setActionPopup({ ...actionPopup, [name]: type == 'checkbox' ? checked : value, informationAboutImplementationTiming: '' });
            }
            else {
                setIsOngoingAction(true);
                setActionPopup({ ...actionPopup, [name]: type == 'checkbox' ? checked : value });
            }
        }
        else if (name == 'category') {
            if (value == 'C' || value == 'S') {
                setShowFuturePossibleActionOnly(true);
                setActionPopup({ ...actionPopup, [name]: type == 'checkbox' ? checked : value, futurePossibleActionOnly: '' });
            }
            else {
                setShowFuturePossibleActionOnly(false);
                setActionPopup({ ...actionPopup, [name]: type == 'checkbox' ? checked : value, futurePossibleActionOnly: '' });
            }
        }
        else {
            setActionPopup({ ...actionPopup, [name]: type == 'checkbox' ? checked : value });
        }
    }

    const handleActionSave = async (e) => {
        e.preventDefault();
        setSavingAction(true);
        setFormErrors({});
        var gmpSelectedValues = '';
        gmpValue.forEach(function (element) {
            if (gmpSelectedValues == '') {
                gmpSelectedValues = element.value.toString();
            }
            else {
                gmpSelectedValues = gmpSelectedValues + ',' + element.value.toString();
            }
        });
        if (actionPopup.actionType == 0) {
            actionPopup.actionType = actionTypes[0].id;
        }
        const errors = {};
        if (parseInt(actionPopup.type) == 0) {
            errors.type = "Please select type";
        }
        if (!actionDueDate && actionPopup.actionType == '45') {
            errors.actionDueDate = "Please enter action due date";
        }
        if (!onGoingFrom && actionPopup.actionType == '46') {
            errors.onGoingFrom = "Please enter on going from";
        }
        if (!actionPopup.title) {
            errors.title = "Please enter action title";
        }
        if (!actionPopup.description) {
            errors.description = "Please enter action details";
        }
        if (actionPopup.activityRiskIds == '') {
            errors.activityRisk = "Please choose an activity risk";
        }
        if (actionPopup.pageId == 0) {
            errors.page = "Please choose a page";
        }
        if (actionPopup.category == undefined || actionPopup.category == null || actionPopup.category == '') {
            errors.category = "Please choose a category";
        }
        else {
            if (actionPopup.category == 'R') {
                if (actionPopup.whatRegulatoryRequirementIsBeingMetWithThisAction == undefined || actionPopup.whatRegulatoryRequirementIsBeingMetWithThisAction == null || actionPopup.whatRegulatoryRequirementIsBeingMetWithThisAction == '') {
                    errors.whatRegulatoryRequirementIsBeingMetWithThisAction = "This is mandatory";
                }
                else {
                    if (actionPopup.whatRegulatoryRequirementIsBeingMetWithThisAction == 'Yes') {
                        if (actionPopup.regulatoryRequirementDescription == undefined || actionPopup.regulatoryRequirementDescription == null || actionPopup.regulatoryRequirementDescription == '') {
                            errors.regulatoryRequirementDescription = "This is mandatory";
                        }
                    }
                }
            }
        }
        var pageObj = pagesList.filter(x => x.id == actionPopup.pageId);
        if (pageObj.length > 0) {
            var pageName = pageObj[0].name;
            if (pageName == "Nutrients") {
                actionPopup.pageId = null;
            }
        }

        var errorFound = false;
        const tempErrors = [...formErrorList];
        let tempRecordUploadList = [...evidenceRecordList];
        var evidenceRecordList1 = [];
        for (var i = 0; i < tempRecordUploadList.length; i++) {
            var obj = {};
            obj.Id = tempRecordUploadList[i].id;
            obj.imageDetail = tempRecordUploadList[i].imageDetail;
            if (obj.imageDetail == undefined || obj.imageDetail == null || obj.imageDetail == '') {
                tempErrors[i].imageDetail = 'This is mandatory';
                errorFound = true;
            }
            else {
                tempErrors[i].imageDetail = '';
            }
            obj.imageName = tempRecordUploadList[i].imageName;
            if (obj.imageName == undefined || obj.imageName == null || obj.imageName == '') {
                tempErrors[i].fileError = 'This is mandatory';
                errorFound = true;
            }
            else {
                tempErrors[i].fileError = '';
            }
            obj.imagePhysicalName = tempRecordUploadList[i].imagePhysicalName;
            obj.imagePath = tempRecordUploadList[i].imagePath;
            obj.UploadDateText = tempRecordUploadList[i].uploadDate != null ? tempRecordUploadList[i].uploadDateText : "";
            if (obj.UploadDateText == undefined || obj.UploadDateText == null || obj.UploadDateText == '') {
                tempErrors[i].uploadDate = 'This is mandatory';
                errorFound = true;
            }
            else {
                tempErrors[i].uploadDate = '';
            }
            evidenceRecordList1.push(obj);
        }

        setFormErrorList(tempErrors);

        setFormErrors(errors);
        if (Object.keys(errors).length == 0 && !errorFound) {
            var section = null;
            if (wholeFarmAction) {
                section = actionPopup.pageId
            }
            var luId = actionPopup.luId;
            let inherentRisks = '';
            if (Array.isArray(inherentRisksObj.inherentRisks)) {
                let inherentRisksArr = [];
                inherentRisksObj.inherentRisks.forEach(risk => {
                    inherentRisksArr.push(risk.value);
                })
                inherentRisks = inherentRisksArr.join(",");
            } else {
                inherentRisks = inherentRisksObj.inherentRisks.toString();
            }

            let significantSpecies = '';
            if (Array.isArray(significantSpeciesObj.significantSpecies)) {
                let significantSpeciesArr = [];
                significantSpeciesObj.significantSpecies.forEach(risk => {
                    significantSpeciesArr.push(risk.value);
                })
                significantSpecies = significantSpeciesArr.join(",");
            } else {
                significantSpecies = significantSpeciesObj.significantSpecies.toString();
            }

            let contaminants = '';
            if (Array.isArray(contaminantObj.contaminants)) {
                let contaminantsArr = [];
                contaminantObj.contaminants.forEach(risk => {
                    contaminantsArr.push(risk.value);
                })
                contaminants = contaminantsArr.join(",");
            } else {
                contaminants = contaminantObj.contaminants.toString();
            }

            let managementAreaObjective = '';

            if (Array.isArray(actionPopup.managementAreaObjective)) {
                let managementAreaObjectiveArr = [];
                actionPopup.managementAreaObjective.forEach(risk => {
                    managementAreaObjectiveArr.push(risk.value);
                })
                managementAreaObjective = managementAreaObjectiveArr.join(",");
            } else {
                managementAreaObjective = actionPopup.managementAreaObjective.toString();
            }
            let managementAreaTarget = '';
            if (Array.isArray(actionPopup.managementAreaTarget)) {
                let managementAreaTargetArr = [];
                actionPopup.managementAreaTarget.forEach(risk => {
                    managementAreaTargetArr.push(risk.value);
                })
                managementAreaTarget = managementAreaTargetArr.join(",");

            } else {
                managementAreaTarget = actionPopup.managementAreaTarget.toString();
            }
            let gmpCategory = '';
            if (Array.isArray(actionPopup.gmpCategory)) {
                let gmpCategoryArr = [];
                actionPopup.gmpCategory.forEach(risk => {
                    gmpCategoryArr.push(risk.value);
                })
                gmpCategory = gmpCategoryArr.join(",");
            } else {
                gmpCategory = actionPopup.gmpCategory.toString();
            }
            let gmp = '';
            if (Array.isArray(actionPopup.gmp)) {
                let gmpArr = [];
                actionPopup.gmp.forEach(risk => {
                    gmpArr.push(risk.value);
                })
                gmp = gmpArr.join(",");
            } else {
                gmp = actionPopup.gmp.toString();
            }

            let form = {
                Id: actionPopup.id, ItemId: actionPopup.itemId, Title: actionPopup.title, Description: actionPopup.description,
                ActionType: parseInt(actionPopup.actionType), DueDate: actionPopup.actionType == '45' ? getParsedDate(actionDueDate) : null,
                RegulatoryRequirement: actionPopup.regulatoryRequirement, CatchmentPriority: actionPopup.catchmentPriority,
                SignificantEnvironmentBenfit: actionPopup.significantEnvironmentBenfit, Priority: parseInt(actionPopup.priority),
                EstimatedCost: parseFloat(actionPopup.estimatedCost), FinancialNotes: actionPopup.financialNotes, GHGItemTypeId: sectionName == "GHG" ? parseInt(actionPopup.type) : null,
                ContaminantIds: contaminants, GoodFarmingPracticeIds: gmpSelectedValues, userId: userId, FarmId: farmId, SectionId: section,
                ActivityRiskId: actionPopup.activityRiskId, ActivityRiskIds: actionPopup.activityRiskIds, InherentRisks: inherentRisks, SignificantSitesAndSpecies: significantSpecies, LUId: luId, FarmEnterpriseId: actionPopup.farmEnterpriseId,
                ExistingAction: actionPopup.existingAction, Category: actionPopup.category == null ? '' : actionPopup.category, RecommendedActionId: actionPopup.recommendedActionId,
                RegulatoryRequirementDescription: actionPopup.regulatoryRequirementDescription, FuturePossibleActionOnly: actionPopup.futurePossibleActionOnly == '' ? null : (actionPopup.futurePossibleActionOnly == 'Yes' ? true : false),
                OnGoingFrom: onGoingFrom != null ? getParsedDate(onGoingFrom) : null, InformationAboutImplementationTiming: actionPopup.informationAboutImplementationTiming,
                DoesThisActionRelateToNewPhysicalWorks: actionPopup.doesThisActionRelateToNewPhysicalWorks, WhatRegulatoryRequirementIsBeingMetWithThisAction: actionPopup.whatRegulatoryRequirementIsBeingMetWithThisAction,
                managementAreaObjective: managementAreaObjective, managementAreaTarget: managementAreaTarget, gmpCategory: gmpCategory, gmp: gmp, ImageUploadList: [],
                evidenceRecordList: evidenceRecordList1
            }
            for (var i = 0; i < imageUploadList.length; i++) {
                var obj = {};
                obj.Id = imageUploadList[i].id;
                obj.ImageDetail = imageUploadList[i].imageDetail;
                obj.ImageName = imageUploadList[i].imageName;
                obj.ImagePhysicalName = imageUploadList[i].imagePhysicalName;
                obj.ImagePath = imageUploadList[i].imagePath;
                form.ImageUploadList.push(obj);
            }
            if (actionPopup.actionType == 0) {
                form.ActionType = actionTypes[0].id;
            }
            const response = await apiPost(
                '/api/action/SaveAction/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response.data.status) {
                var currentAction = ++actionPopup.currentAction;
                if (currentAction > actionPopup.totalActions) {
                    if (refreshRiskSummary != undefined) {
                        await refreshRiskSummary();
                        document.getElementById('btnActionSave').style.display = "none";
                        toast.success("Action details Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                        setTempId(parseInt(response.data.content));
                        setSavingAction(false);
                        handleActionClose();
                        refreshToken();
                    }
                    else {
                        document.getElementById('btnActionSave').style.display = "none";
                        toast.success("Action details Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                        setTempId(parseInt(response.data.content));
                        setSavingAction(false);
                        handleActionClose();
                        window.location.reload(true);
                    }
                }
                else {
                    setActionTypes(actionWholeData.actionTypes);
                    setContaminantList(actionWholeData.contaminantList);
                    setContaminantListSelectedValues(actionWholeData.contaminants);
                    setActivityRiskModel(actionWholeData.activityRiskModel);
                    setFarmAPTActionList(actionWholeData.farmAPTActionList);
                    for (var i = 0; i < actionWholeData.goodFarmingPracticeGroups.length; i++) {
                        var goodFarmingPractices = actionWholeData.goodFarmingPracticeList.filter(x => x.group1 == actionWholeData.goodFarmingPracticeGroups[i].name);
                        options.push(createGroup(actionWholeData.goodFarmingPracticeGroups[i].name, goodFarmingPractices, setGmpValue));
                    }
                    setManagementAreaObjectiveList(actionWholeData.managementAreaObjectiveList);
                    setTempManagementAreaTargetList(actionWholeData.managementAreaTargetList);
                    setGMPCategoryList(actionWholeData.gmpCategoryList);
                    setTempGMPList(actionWholeData.gmpList);
                    setShowEnvironmentCanterbury(actionWholeData.showEnvironmentCanterbury);
                    setSubRegion(actionWholeData.subRegion);
                    setGmpOptions(options);
                    setActionDueDate(null);
                    setOnGoingFrom(null);
                    setActionPopup({
                        ...actionPopup, riskDescription: activityRiskPopup.recommendedActionList[currentAction - 1].description, type: sectionName == "GHG" ? itemTypeSelect[0].id : itemTypeId, name: itemName, id: 0,
                        actionType: parseInt(actionWholeData.actionTypes[0].id), title: activityRiskPopup.recommendedActionList[currentAction - 1].label,
                        description: '', actionType: 0,
                        regulatoryRequirement: 'Yes', catchmentPriority: 'Yes', significantEnvironmentBenfit: 'Yes', priority: '1',
                        estimatedCost: '', financialNotes: '', closeOutDetail: '', isCloseout: false, itemId: itemId,
                        createdByName: user.fullName, actualCost: '', actualCostNotes: '', existingAction: false, category: '',
                        regulatoryRequirementDescription: '', futurePossibleActionOnly: '', doesThisActionRelateToNewPhysicalWorks: false,
                        currentAction: currentAction, recommendedActionId: activityRiskPopup.recommendedActionList[currentAction - 1].value,
                        managementAreaObjective: [], managementAreaTarget: [], gmpCategory: [], gmp: [], onGoingFrom: null, informationAboutImplementationTiming: '',
                        whatRegulatoryRequirementIsBeingMetWithThisAction: '',
                    });
                    setActionCreatedOn(getParsedDate1(new Date()));
                    setIsFarmOperational(actionWholeData.isOperational);
                    document.getElementById('btnActionSave').style.display = "block";
                    setSavingAction(false);
                    refreshToken();
                }
            }
        }
        else {
            setSavingAction(false);
        }
        
    }

    const getParsedDate = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "-" + mm + "-" + yyyy;
        return date.toString();
    }

    const getParsedDate1 = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "/" + mm + "/" + yyyy;
        return date.toString();
    }

    const getDateFromString = (date) => {
        var dd = date.split('/')[0];
        var mm = date.split('/')[1];
        var yyyy = date.split('/')[2];
        var newDate = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        return newDate;
    }
    const getDateFromString1 = (date) => {
        var dd = date.split('-')[0];
        var mm = date.split('-')[1];
        var yyyy = date.split('-')[2];
        var newDate = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        return newDate;
    }

    const handleActionCloseSave = async (e) => {
        e.preventDefault();
        setSavingActionCloseSave(true);
        setFormErrors({});
        const errors = {};
        if (!submitDate) {
            errors.submitDate = "Please enter submit date";
        }
        setFormErrors(errors);
        if (Object.keys(errors).length == 0) {
            let form = {
                Id: actionPopup.id, SubmitDate: getParsedDate(submitDate), PastTargetOutlineReasons: actionPopup.pastTargetOutlineReasons,
                CloseOutDetail: actionPopup.closeOutDetail, ActualCost: parseFloat(actionPopup.actualCost),
                ActualCostNotes: actionPopup.actualCostNotes, userId: userId
            }
            const response = await apiPost(
                '/api/action/SaveActionClose/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response.data.status) {
                //await refreshRiskSummary();
                //setSavingActionCloseSave(false);
                //toast.success("Action details Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                //handleActionClose();

                if (refreshRiskSummary != undefined) {
                    await refreshRiskSummary();
                    toast.success("Action details Saved!", { duration: 5000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                    setSavingActionCloseSave(false);
                    handleActionClose();
                }
                else {
                    toast.success("Action details Saved!", { duration: 5000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                    setSavingActionCloseSave(false);
                    handleActionClose();
                    window.location.reload(true);
                }
            }
        }
        else {
            setSavingActionCloseSave(false);
        }
    }

    const handleRegulatoryRequirementChange = (e) => {
        var priority = '';
        if (e.target.value == 'Yes') {
            priority = '1';
        }
        else {
            if (actionPopup.catchmentPriority == 'Yes') {
                if (actionPopup.significantEnvironmentBenfit == 'Yes') {
                    priority = '2';
                }
                else {
                    priority = '4';
                }
            }
            else {
                if (actionPopup.significantEnvironmentBenfit == 'Yes') {
                    priority = '3';
                }
                else {
                    priority = '5';
                }
            }
        }
        setActionPopup({ ...actionPopup, regulatoryRequirement: e.target.value, priority: priority });
    }

    const handleCatchmentPriorityChange = (e) => {
        var priority = '';
        if (actionPopup.regulatoryRequirement == 'Yes') {
            priority = '1';
        }
        else {
            if (e.target.value == 'Yes') {
                if (actionPopup.significantEnvironmentBenfit == 'Yes') {
                    priority = '2';
                }
                else {
                    priority = '4';
                }
            }
            else {
                if (actionPopup.significantEnvironmentBenfit == 'Yes') {
                    priority = '3';
                }
                else {
                    priority = '5';
                }
            }
        }
        setActionPopup({ ...actionPopup, catchmentPriority: e.target.value, priority: priority });
    }

    const handleSignificantEnvironmentBenfitChange = (e) => {
        var priority = '';
        if (actionPopup.regulatoryRequirement == 'Yes') {
            priority = '1';
        }
        else {
            if (actionPopup.catchmentPriority == 'Yes') {
                if (e.target.value == 'Yes') {
                    priority = '2';
                }
                else {
                    priority = '4';
                }
            }
            else {
                if (e.target.value == 'Yes') {
                    priority = '3';
                }
                else {
                    priority = '5';
                }
            }
        }
        setActionPopup({ ...actionPopup, significantEnvironmentBenfit: e.target.value, priority: priority });
    }

    const handleActivityRiskPopup = (e) => {
        e.preventDefault();
        if (actionPopup.pageId == 0) {
            setFormErrors({});
            const errors = {};
            if (actionPopup.pageId == 0) {
                errors.page = "Please choose a page";
            }
            setFormErrors(errors);
            return false;
        }
        else {
            setActivityRiskPopup({ ...activityRiskPopup, showActivityRisk: true, activityRiskId: 0, activityRiskIds: '', activityRiskText: '', activityId: 0, enterpriseTypeId: 0, luId: '', recommendedActionId: 0 });
        }
    }

    const handleActivityRiskSelect = (e) => {
        e.preventDefault();
        if (activityRiskPopup.activityRiskIds == '' || activityRiskPopup.luId == '' || (activityRiskPopup.recommendedActionList.length == 0 && activityRiskPopup.recommendedActionText == "")) {
            toast.error("Please make sure you have selected a RISK, Land Units, and Possible Action before continuing", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            return false;
        }
        else {
            setActivityRiskId(activityRiskPopup.activityRiskId);

            var activityRiskIds = [];
            if (activityRiskPopup.activityRiskIds != undefined && activityRiskPopup.activityRiskIds != null && activityRiskPopup.activityRiskIds != '') {
                var activityRiskIdList = activityRiskPopup.activityRiskIds.split(',');
                for (var i = 0; i < activityRiskIdList.length; i++) {
                    activityRiskIds.push(activityRiskIdList[i]);
                }
            }
            setActivityRiskIdList(activityRiskIds);
            setActivityRisk(activityRiskPopup.activityRiskText);
            setActivityRiskPopup({ ...activityRiskPopup, showActivityRisk: false });
            if (actionPopup.id == 0) {
                if (activityRiskPopup.naActivityRisk) {
                    if (wholeFarmAction) {
                        setActionPopup({ ...actionPopup, riskDescription:'', title: '', description: '', activityRiskId: activityRiskPopup.activityRiskId, activityRiskIds: activityRiskPopup.activityRiskIds, luId: activityRiskPopup.luId, farmEnterpriseId: activityRiskPopup.activityId, recommendedActionId: activityRiskPopup.recommendedActionId })
                    }
                    else if (ghgNutrient) {
                        setActionPopup({ ...actionPopup, riskDescription:'', title: '', description: '', activityRiskId: activityRiskPopup.activityRiskId, activityRiskIds: activityRiskPopup.activityRiskIds, luId: activityRiskPopup.luId, farmEnterpriseId: activityRiskPopup.activityId, recommendedActionId: activityRiskPopup.recommendedActionId })
                    }
                    else {
                        setActionPopup({ ...actionPopup, riskDescription:'', title: '', description: '', activityRiskId: activityRiskPopup.activityRiskId, activityRiskIds: activityRiskPopup.activityRiskIds, luId: activityRiskPopup.luId, farmEnterpriseId: activityRiskPopup.activityId, recommendedActionId: activityRiskPopup.recommendedActionId })
                    }
                }
                else {
                    if (wholeFarmAction) {
                        setActionPopup({
                            ...actionPopup, title: activityRiskPopup.recommendedActionList[0].label == 'Record a specific action' ? null : activityRiskPopup.recommendedActionList[0].label, riskDescription: activityRiskPopup.recommendedActionList[0].description, activityRiskId: activityRiskPopup.activityRiskId, activityRiskIds: activityRiskPopup.activityRiskIds, luId: activityRiskPopup.luId, farmEnterpriseId: activityRiskPopup.activityId, recommendedActionId: activityRiskPopup.recommendedActionList[0].value,
                            totalActions: activityRiskPopup.recommendedActionList.length, currentAction: 1
                        })
                    }
                    else if (ghgNutrient) {
                        setActionPopup({
                            ...actionPopup, title: activityRiskPopup.recommendedActionList[0].label == 'Record a specific action' ? null : activityRiskPopup.recommendedActionList[0].label, riskDescription: activityRiskPopup.recommendedActionList[0].description, activityRiskId: activityRiskPopup.activityRiskId, activityRiskIds: activityRiskPopup.activityRiskIds, luId: activityRiskPopup.luId, farmEnterpriseId: activityRiskPopup.activityId, recommendedActionId: activityRiskPopup.recommendedActionList[0].value,
                            totalActions: activityRiskPopup.recommendedActionList.length, currentAction: 1
                        })
                    }
                    else {
                        setActionPopup({
                            ...actionPopup, title: activityRiskPopup.recommendedActionList[0].label == 'Record a specific action' ? null : activityRiskPopup.recommendedActionList[0].label, riskDescription: activityRiskPopup.recommendedActionList[0].description, activityRiskId: activityRiskPopup.activityRiskId, activityRiskIds: activityRiskPopup.activityRiskIds, luId: activityRiskPopup.luId, farmEnterpriseId: activityRiskPopup.activityId, recommendedActionId: activityRiskPopup.recommendedActionList[0].value,
                            totalActions: activityRiskPopup.recommendedActionList.length, currentAction: 1
                        })
                    }
                }
            }
            else {
                if (typeof activityRiskPopup.recommendedActionList === 'object' && activityRiskPopup.recommendedActionList.constructor === Object) {
                    setActionPopup({ ...actionPopup, title: activityRiskPopup.recommendedActionList.label == 'Record a specific action' ? null : activityRiskPopup.recommendedActionList[0].label, riskDescription: activityRiskPopup.recommendedActionList.description, activityRiskId: activityRiskPopup.activityRiskId, activityRiskIds: activityRiskPopup.activityRiskIds, luId: activityRiskPopup.luId, recommendedActionId: activityRiskPopup.recommendedActionList.value })
                }
                else {
                    setActionPopup({ ...actionPopup, title: activityRiskPopup.recommendedActionList[0].label == 'Record a specific action' ? null : activityRiskPopup.recommendedActionList[0].label, riskDescription: activityRiskPopup.recommendedActionList[0].description, activityRiskId: activityRiskPopup.activityRiskId, activityRiskIds: activityRiskPopup.activityRiskIds, luId: activityRiskPopup.luId, recommendedActionId: activityRiskPopup.recommendedActionList[0].value })
                }
            }
        }
    }

    const handleActionCloseWrapper = async () => {
        if (actionPopup.id == 0 && actionPopup.currentAction > actionPopup.totalActions) {
            if (refreshRiskSummary != undefined) {
                await refreshRiskSummary();
            }
            handleActionClose();
        }
        else if (actionPopup.id != 0) {
            handleActionClose();
        }
        else {
            if (actionPopup.totalActions == 1) {
                handleActionClose();
            }
            else {
                if (actionPopup.currentAction == 1 && actionPopup.totalActions > 1) {
                    setActionCancelPopup({ ...actionCancelPopup, showActionCancelPopup: true, id: 0, message: 'This will cancel the current action and any other selected but not yet saved. Are you sure you wish to continue?' })
                }
                else if (actionPopup.currentAction != actionPopup.totalActions && actionPopup.totalActions > 1) {
                    setActionCancelPopup({ ...actionCancelPopup, showActionCancelPopup: true, id: 0, message: 'This will cancel the current action and any not yet saved. Previous actions already saved will remain you will need to remove these separately if needed. Are you sure you wish to continue?' })
                }
                else if (actionPopup.currentAction == actionPopup.totalActions && actionPopup.totalActions > 1) {
                    setActionCancelPopup({ ...actionCancelPopup, showActionCancelPopup: true, id: 0, message: 'By cancelling this action will not be saved, but the previous actions have already been saved. You will need to remove these separately if needed. Are you sure you wish to continue?' })
                }
            }
        }
    }
    const [actionCancelPopup, setActionCancelPopup] = useState({ showActionCancelPopup: false, id: 0 });
    const handleActionCancelPopupClose = () => {
        setActionCancelPopup({ ...actionCancelPopup, showActionCancelPopup: false, id: 0 })
    }
    const [processingCancel, setProcessingCancel] = useState(false);
    const handleActionCancel = async () => {
        setProcessingCancel(true);
        if (refreshRiskSummary != undefined) {
            await refreshRiskSummary();
        }
        setProcessingCancel(false);
        setActionCancelPopup({ ...actionCancelPopup, showActionCancelPopup: false, id: 0 })
        handleActionClose();
    }

    const handleActivityRiskClose = (e) => {
        setActivityRiskPopup({ ...activityRiskPopup, showActivityRisk: false, activityId: 0, luId: 0, activityRiskId: 0, activityRiskIds: '', activityRiskText: '', recommendedActionId: 0, recommendedActionText: '', recommendedActionDescription: '' });
    }

    function handleUploadReqPopupNoClose() {
        window.open(redirectPage, "_self");
    }

    const getActionbyId = async (actionId) => {

        const response = await apiGet(
            '/api/action/GetAction/', {
            params: { Id: actionId, sectionId: sectionId, farmId: farmId }
        }
        );
        if (response.data.status) {
            setActionTypes(response.data.content.actionTypes);
            setContaminantList(response.data.content.contaminantList);
            setContaminantListSelectedValues(response.data.content.contaminants);
            for (var i = 0; i < response.data.content.goodFarmingPracticeGroups.length; i++) {
                var goodFarmingPractices = response.data.content.goodFarmingPracticeList.filter(x => x.group1 == response.data.content.goodFarmingPracticeGroups[i].name);
                options.push(createGroup(response.data.content.goodFarmingPracticeGroups[i].name, goodFarmingPractices, setGmpValue));
            }
            setGmpOptions(options);
            if (actionId != 0) {
                flushSync(() => {
                    setActionPopup({
                        ...actionPopup, id: response.data.content.id, type: response.data.content.ghgItemTypeId, name: itemName, actionType: response.data.content.actionType, title: response.data.content.title,
                        description: response.data.content.description, regulatoryRequirement: response.data.content.regulatoryRequirement, catchmentPriority: response.data.content.catchmentPriority,
                        significantEnvironmentBenfit: response.data.content.significantEnvironmentBenfit, priority: response.data.content.priority, estimatedCost: response.data.content.estimatedCost,
                        financialNotes: response.data.content.financialNotes, pastTargetOutlineReasons: response.data.content.pastTargetOutlineReasons, closeOutDetail: response.data.content.closeOutDetail
                        , isCloseout: response.data.content.isCloseout, itemId: itemId, createdByName: response.data.content.createdByName, createdDate: response.data.content.createdOn
                    });
                });
                setActionDueDate(getDateFromString(response.data.content.dueDateText));
                if (response.data.content.submitDateText != '') {
                    setSubmitDate(getDateFromString(response.data.content.submitDateText));
                }
                setIsFarmOperational(response.data.content.isOperational);
                setGmpValue(response.data.content.goodFarmingPractices);
            }
        }
    }

    function handleUploadReqPopupYesClose() {
        getActionbyId(tempId);
        setUploadReqPopup({ showUploadReqPopup: false });
    }

    const handleActionDelete = async (e) => {
        e.preventDefault();
        const id = actionDeletePopup.id;
        try {
            const response = await apiGet(
                '/api/action/DeleteAction/', {
                params: {
                    id: id, userId: userId
                }
            }
            );
            window.location.reload(true);
        } catch (error) {
            console.error('Error:', error);
        }
    }
    const handleActionDeleteClick = (actionId) => {
        setActionDeletePopup({ ...actionDeletePopup, showActionDeletePopup: true, id: actionId })
    }

    const handleActionDeletePopupClose = () => {
        setActionDeletePopup({ ...actionDeletePopup, showActionDeletePopup: false, id: 0 })
    }

    const handleMultiSelectInherentRiskChange = (e) => {
        setInherentRisksObj({ ...inherentRisksObj, inherentRisks: e });
    }

    const handleMultiSelectSignificantSpeciesChange = (e) => {
        setSignificantSpeciesObj({ ...significantSpeciesObj, significantSpecies: e });
    }

    const handleMultiSelectContaminantChange = (e) => {
        setContaminantObj({ ...contaminantObj, contaminants: e });
    }
    const handleSetActionDueDate = (date) => {
        setActionDueDate(date);
        if (submitDate != undefined && submitDate != null) {
            if (submitDate <= date) {
                setShowPastTargetOutlineReasons(false);
            }
            else {
                setShowPastTargetOutlineReasons(true);
            }
        }
    }
    const handleSetOnGoingFrom = (date) => {
        setOnGoingFrom(date);
    }
    const handleSetSubmitDate = (date) => {
        setSubmitDate(date);
        if (actionDueDate != undefined && actionDueDate != null) {
            if (date <= actionDueDate) {
                setShowPastTargetOutlineReasons(false);
            }
            else {
                setShowPastTargetOutlineReasons(true);
            }
        }
    }

    const handleMultiSelectManagementAreaObjectiveChange = (e) => {
        setManagementAreaTargetList([]);
        var selectedManagementAreaTargetList = [];
        let myArrayFiltered = [];
        if (actionPopup.managementAreaTarget != undefined && actionPopup.managementAreaTarget.length > 0) {
            selectedManagementAreaTargetList = actionPopup.managementAreaTarget.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
            myArrayFiltered = tempManagementAreaTargetList.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
        }
        else {
            myArrayFiltered = tempManagementAreaTargetList.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
        }
        setActionPopup({ ...actionPopup, managementAreaObjective: e, managementAreaTarget: selectedManagementAreaTargetList });
        setManagementAreaTargetList(myArrayFiltered);
    }

    const handleMultiSelectManagementAreaTargetChange = (e) => {
        setActionPopup({ ...actionPopup, managementAreaTarget: e });
    }

    const handleMultiSelectGMPCategoryChange = (e) => {
        setGMPList([]);
        var selectedGMPList = [];
        let myArrayFiltered = [];
        if (actionPopup.gmp != undefined && actionPopup.gmp.length > 0) {
            selectedGMPList = actionPopup.gmp.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
            myArrayFiltered = tempGMPList.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
        }
        else {
            myArrayFiltered = tempGMPList.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
        }
        setActionPopup({ ...actionPopup, gmpCategory: e, gmp: selectedGMPList });
        setGMPList(myArrayFiltered);
    }

    const handleMultiSelectGMPChange = (e) => {
        setActionPopup({ ...actionPopup, gmp: e });
    }

    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Modal size="lg" backdrop={false} className="itemPopup" isOpen={showActionPopupModal}>
                <ModalHeader toggle={handleActionClose}> {actionPopupName}</ModalHeader>
                <ModalBody>
                    {!pageDisabled &&
                        <Row>
                            <Col sm="4">
                                <FormGroup>
                                    <Label className="text-capitalize">Choose Action Feature Category</Label>
                                    {pagesList == undefined && <p><em>Loading...</em></p>}
                                    {pagesList != undefined && pagesList != null &&
                                        <Input disabled={pageDisabled} type="select" value={actionPopup.pageId} onChange={handleInputChange} name="pageId" id="pageId">
                                            {pagesList.map(items =>
                                                <option key={uuid()} value={items.id}>{items.name}</option>
                                            )}
                                        </Input>
                                    }
                                </FormGroup>
                                {formErrors.page != undefined &&
                                    <p className="errorMessage">{formErrors.page}</p>
                                }
                            </Col>
                        </Row>
                    }
                    <Row xs="3" style={{ display: "none" }}>
                        <Col>
                            <FormGroup>
                                <Label className="text-capitalize">Created</Label>
                                <Input type="text" name="actionCreatedOn" id="actionCreatedOn" value={actionCreatedOn} readOnly disabled />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label className="text-capitalize">Created by</Label>
                                <Input type="text" name="txtPage" id="txtPage" value={actionPopup.createdByName} readOnly disabled />
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup>
                                <Label className="text-capitalize">Id</Label>
                                <Input type="text" name="txtPage" id="txtPage" value={actionPopup.id} readOnly disabled />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row xs="3" style={{ display: "none" }}>
                        <Col>
                            <FormGroup>
                                <Label className="text-capitalize">Page</Label>
                                <Input type="text" name="txtPage" id="txtPage" value={sectionName} readOnly disabled />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label className="text-capitalize">Type</Label>
                                {itemTypeSelect == undefined && <p><em>Loading...</em></p>}
                                {itemTypeSelect != undefined && itemTypeSelect != null &&
                                    <Input disabled={itemTypeDisabled} type="select" value={actionPopup.type} onChange={handleInputChange} name="type" id="type">
                                        {itemTypeSelect.map(items =>
                                            <option key={uuid()} value={items.id}>{items.name}</option>
                                        )}
                                    </Input>
                                }
                            </FormGroup>
                            {formErrors.type != undefined &&
                                <p className="errorMessage">{formErrors.type}</p>
                            }
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label className="text-capitalize">Name</Label>
                                <Input type="text" name="txtName" id="txtName" value={actionPopup.name} readOnly disabled />
                            </FormGroup>
                        </Col>
                    </Row>
                    {showActivityRisk && <Row>
                        <Col sm="12">
                            <Label className="text-capitalize">Select which Risk this action will be mitigating, or helping to mitigate</Label>
                        </Col>
                        <Col sm="12">
                            <Button style={{}} onClick={handleActivityRiskPopup} color="primary" >{actionPopup.id == 0 ? "Select Risk" : "Edit Risk and LU detail"}</Button>
                        </Col>
                        <Col sm="12">
                            <Input type="hidden" name="activityRiskId" id="activityRiskId" value={activityRiskId} />
                            <Input type="hidden" name="activityRiskIds" id="activityRiskIds" value={activityRiskIds} />
                            <Input type="text" style={{ marginTop: "10px" }} name="activityRisk" id="activityRisk" value={activityRisk} readOnly disabled />
                        </Col>
                        {formErrors.activityRisk != undefined &&
                            <p className="errorMessage">{formErrors.activityRisk}</p>
                        }
                    </Row>}
                    <Row>
                        <Col sm="8">
                            <Row style={{ marginTop: "10px" }}>
                                <Col sm="6" style={{ display: "flex", justifyContent: "space-between" }}>
                                    <FormGroup style={{ display: "flex", justifyContent: "space-between" }}>
                                        <Input className="" type="checkbox" checked={actionPopup.existingAction} onChange={handleInputChange} name="existingAction" id="existingAction" />&nbsp;&nbsp;&nbsp;
                                        <Label className="text-capitalize">Select if this is an Existing Action</Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <FormGroup>
                                        <Label className="text-capitalize">Action Title</Label>
                                        <Input type="text" name="title" id="title" value={actionPopup.title} onChange={handleInputChange} />
                                    </FormGroup>
                                    {formErrors.title != undefined &&
                                        <p className="errorMessage">{formErrors.title}</p>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <FormGroup>
                                        <Label className="form-labelSummary">{actionPopup.riskDescription}</Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                        <Col sm="4">
                            <Row>
                                <Col sm="12">
                                    <br />
                                    <div className="smart-description">
                                        <span className="smart-list" style={{ fontSize: "12px", fontWeight: "700" }}>
                                            Use the SMART action planner:
                                        </span>
                                        <span className="smart-list" style={{ fontSize: "11px" }}>
                                            <span style={{ fontSize: "11px" }} className="smart-letter">S</span> What is the <strong>S</strong>
                                            pecific outline of the risk and action implemented?
                                        </span>
                                        <span className="smart-list" style={{ fontSize: "11px" }}>
                                            <span style={{ fontSize: "11px" }} className="smart-letter">M</span> How is it going to be{" "}
                                            <strong>M</strong>easured?
                                        </span>
                                        <span className="smart-list" style={{ fontSize: "11px" }}>
                                            <span style={{ fontSize: "11px" }} className="smart-letter">A</span> Can it be <strong>A</strong>chieved?
                                        </span>
                                        <span className="smart-list" style={{ fontSize: "11px" }}>
                                            <span style={{ fontSize: "11px" }} className="smart-letter">R</span> Does the action address the{" "}
                                            <strong>R</strong>isks?
                                        </span>
                                        <span className="smart-list" style={{ fontSize: "11px" }}>
                                            <span style={{ fontSize: "11px" }} className="smart-letter">T</span> What is the <strong>T</strong>ime
                                            frame around action?
                                        </span>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="12">
                            <FormGroup>
                                <Label className="text-capitalize">Action Description</Label>
                                <Input placeholder="Detail the SMART action here" type="textarea" name="description" id="description" value={actionPopup.description} onChange={handleInputChange} />
                            </FormGroup>
                            {formErrors.description != undefined &&
                                <p className="errorMessage">{formErrors.description}</p>
                            }
                        </Col>
                    </Row>   
                    <Row style={{ display: "none" }}>
                        <Col>
                            <FormGroup>
                                <div className="inherentrisks​-header">Inherent vulnerability​ <i>(Select Inherent vulnerability from this LU which this Action mitigates or manages)</i></div>
                                <Select closeMenuOnSelect={false} className="dropdown"
                                    placeholder="Select Inherent Risks"
                                    value={inherentRisksObj.inherentRisks}
                                    options={inherentRisksObj.inherentRisksList}
                                    onChange={handleMultiSelectInherentRiskChange}
                                    isMulti hideSelectedOptions={false}
                                    isClearable
                                    components={{
                                        Option
                                    }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    {
                        significantSpeciesObj.significantSpeciesList.length > 0 &&
                        <Row style={{ display: "none" }}>
                            <Col>
                                <FormGroup>
                                    <div className="sitesspecies-header">Sites and Species of Cultural Significance​ <i>(select items this action can apply to)</i></div>
                                    <Select
                                        closeMenuOnSelect={false}
                                        className="dropdown"
                                        placeholder="Select Significant Sites and Species"
                                        value={significantSpeciesObj.significantSpecies}
                                        options={significantSpeciesObj.significantSpeciesList}
                                        onChange={handleMultiSelectSignificantSpeciesChange}
                                        isMulti hideSelectedOptions={false}
                                        isClearable
                                        components={{
                                            Option
                                        }}
                                    />

                                </FormGroup>

                            </Col>
                        </Row>
                    }
                    <Row style={{ display: "none" }}>
                        <Col>
                            <FormGroup>
                                <div className="contaminants-header">Contaminants </div>
                                <Select
                                    closeMenuOnSelect={false}
                                    className="dropdown"
                                    placeholder="Select Contaminants"
                                    value={contaminantObj.contaminants}
                                    options={contaminantObj.contaminantList}
                                    onChange={handleMultiSelectContaminantChange}
                                    isMulti hideSelectedOptions={false}
                                    isClearable
                                    components={{
                                        Option
                                    }}
                                />

                            </FormGroup>

                        </Col>
                    </Row>
                    <Row>
                        <Col sm="12">
                            <Row>
                                <Col sm="3">
                                    <FormGroup>
                                        <Label className="text-capitalize">Category</Label>
                                        <Input type="select" value={actionPopup.category} onChange={handleInputChange} name="category" id="category">
                                            <option value="">Select</option>
                                            <option value="R">Regulatory</option>
                                            <option value="C">Catchment</option>
                                            <option value="S">Supplementary</option>
                                        </Input>
                                    </FormGroup>
                                    {formErrors.category != undefined &&
                                        <p className="errorMessage">{formErrors.category}</p>
                                    }
                                </Col>
                                {actionPopup.category == 'R' &&
                                    <>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label className="text-capitalize">Is this Action being used to comply with other regulatory requirements?</Label>
                                                <Input type="select" value={actionPopup.whatRegulatoryRequirementIsBeingMetWithThisAction} onChange={handleInputChange} name="whatRegulatoryRequirementIsBeingMetWithThisAction" id="whatRegulatoryRequirementIsBeingMetWithThisAction">
                                                    <option value="">Select</option>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </Input>
                                        </FormGroup>
                                        {formErrors.whatRegulatoryRequirementIsBeingMetWithThisAction != undefined &&
                                            <p className="errorMessage">{formErrors.whatRegulatoryRequirementIsBeingMetWithThisAction}</p>
                                        }
                                        </Col>
                                        <Col sm="3">
                                            <FormGroup>
                                                <Label className="text-capitalize">Regulatory Requirement (e.g. Rule 15)</Label>
                                                <Input type="text" name="regulatoryRequirementDescription" id="regulatoryRequirementDescription" value={actionPopup.regulatoryRequirementDescription} onChange={handleInputChange} />
                                        </FormGroup>
                                        {formErrors.regulatoryRequirementDescription != undefined &&
                                            <p className="errorMessage">{formErrors.regulatoryRequirementDescription}</p>
                                        }
                                        </Col>
                                    </>
                                }
                            </Row>
                            <br />
                            <Row>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label className="text-capitalize">Type</Label>
                                        {actionTypes == undefined && <p><em>Loading...</em></p>}
                                        {actionTypes != undefined && actionTypes != null &&
                                            <Input type="select" value={actionPopup.actionType} onChange={handleInputChange} name="actionType" id="actionType">
                                                {actionTypes.map(items =>
                                                    <option key={uuid()} value={items.id}>{items.name}</option>
                                                )}
                                            </Input>
                                        }
                                    </FormGroup>
                                </Col>
                                {!isOngoingAction &&
                                    <Col sm="4">
                                        <FormGroup>
                                            <Label className="text-capitalize">Action Due</Label>
                                            <DatePicker showYearDropdown yearDropdownItemNumber={15} style={{ width: `100%` }} selected={actionDueDate} onChange={(date) => handleSetActionDueDate(date)}
                                                name="actionDueDate" dateFormat="dd/MM/yyyy" className="form-control" />
                                        </FormGroup>
                                        {formErrors.actionDueDate != undefined &&
                                            <p className="errorMessage">{formErrors.actionDueDate}</p>
                                        }
                                    </Col>
                                }
                                {isOngoingAction &&
                                    <Col sm="4">
                                        <FormGroup>
                                            <Label className="text-capitalize">Ongoing From</Label>
                                            <DatePicker showYearDropdown yearDropdownItemNumber={15} style={{ width: `100%` }} selected={onGoingFrom} onChange={(date) => handleSetOnGoingFrom(date)}
                                                name="onGoingFrom" dateFormat="dd/MM/yyyy" className="form-control" />
                                        </FormGroup>
                                        {formErrors.onGoingFrom != undefined &&
                                            <p className="errorMessage">{formErrors.onGoingFrom}</p>
                                        }
                                    </Col>}
                                {showFuturePossibleActionOnly &&
                                    <Col sm="4" style={{ display: "none" }}>
                                        <FormGroup>
                                            <Label className="text-capitalize">Future Possible Action Only</Label>
                                            <Input type="select" value={actionPopup.futurePossibleActionOnly} onChange={handleInputChange} name="futurePossibleActionOnly" id="futurePossibleActionOnly">
                                                <option value="">Select</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                }
                                <Col sm="12">
                                    <FormGroup>
                                        <Label className="text-capitalize">Please provide information about the implementation timing</Label>
                                        <Input type="text" name="informationAboutImplementationTiming" id="informationAboutImplementationTiming" value={actionPopup.informationAboutImplementationTiming} onChange={handleInputChange} />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Row style={{ display: "none" }}>
                        <Col sm="3">
                            <Label className="text-capitalize">Regulatory Requirement</Label>
                            <Input type="select" value={actionPopup.regulatoryRequirement} onChange={handleRegulatoryRequirementChange} name="regulatoryRequirement" id="regulatoryRequirement">
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </Input>
                        </Col>
                        <Col sm="3">
                            <Label className="text-capitalize">Catchment Priority</Label>
                            <Input type="select" value={actionPopup.catchmentPriority} onChange={handleCatchmentPriorityChange} name="catchmentPriority" id="catchmentPriority">
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </Input>
                        </Col>
                        <Col sm="4">
                            <Label className="text-capitalize">Provide a Significant Environment Benefit</Label>
                            <Input type="select" value={actionPopup.significantEnvironmentBenfit} onChange={handleSignificantEnvironmentBenfitChange} name="significantEnvironmentBenfit" id="significantEnvironmentBenfit">
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                            </Input>
                        </Col>
                        <Col sm="2">
                            <Label className="text-capitalize">Priority</Label>
                            <br />
                            <span className="badge badge-warning" id="SaveGHGAction_Priority">{actionPopup.priority}</span>
                        </Col>
                    </Row>
                    {isDairyActivity &&
                        <Row>
                            <Col sm="12">
                                <FormGroup>
                                    <Label className="text-capitalize">Good Farming Practices</Label>
                                    <Select
                                        onChange={option => {
                                            return setGmpValue(option);
                                        }}
                                        closeMenuOnSelect={false}
                                        isMulti
                                        options={gmpOptions}
                                        value={gmpValue}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    }

                    {!wholeFarmAction && !isGHGNutrient &&
                        <Row>
                            <Col sm="4">
                                <FormGroup>
                                    <Label className="text-capitalize">Does this action relate to new physical works?</Label>&nbsp;&nbsp;&nbsp;
                                    <br />
                                    <Input className="" type="checkbox" checked={actionPopup.doesThisActionRelateToNewPhysicalWorks} onChange={handleInputChange} name="doesThisActionRelateToNewPhysicalWorks" id="doesThisActionRelateToNewPhysicalWorks" />
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    {/*{showEnvironmentCanterbury && <>*/}
                    {/*    <Row>*/}
                    {/*        <Col sm="12">*/}
                    {/*            <span className="smart-list" style={{ fontSize: "16px", fontWeight: "700" }}>*/}
                    {/*                Environment Canterbury*/}
                    {/*            </span>*/}
                    {/*        </Col>*/}
                    {/*        <Col sm="12">*/}
                    {/*            <span className="smart-list" style={{ fontSize: "12px", fontWeight: "500" }}>*/}
                    {/*                Please note properties in Canterbury are required to meet Schedule 7 and GMP requirement - please choose from the lists below which Objectives, Targets and GMPs this action relates to.*/}
                    {/*            </span>*/}
                    {/*        </Col>*/}
                    {/*    </Row>*/}
                    {/*    <Row>*/}
                    {/*        <Col sm="3">*/}
                    {/*            <span className="smart-list" style={{ fontSize: "14px", fontWeight: "700" }}>*/}
                    {/*                Schedule 7*/}
                    {/*            </span>*/}
                    {/*        </Col>*/}
                    {/*        <Col sm="5">*/}
                    {/*            <FormGroup>*/}
                    {/*                <Label className="text-capitalize">Management Areas / Objective(s)</Label>*/}
                    {/*                <Select*/}
                    {/*                    closeMenuOnSelect={false}*/}
                    {/*                    className="dropdown"*/}
                    {/*                    placeholder="Select Management Areas / Objective(s)"*/}
                    {/*                    value={actionPopup.managementAreaObjective}*/}
                    {/*                    options={managementAreaObjectiveList}*/}
                    {/*                    onChange={handleMultiSelectManagementAreaObjectiveChange}*/}
                    {/*                    isMulti hideSelectedOptions={false}*/}
                    {/*                    isClearable*/}
                    {/*                    components={{*/}
                    {/*                        Option*/}
                    {/*                    }}*/}
                    {/*                />*/}
                    {/*            </FormGroup>*/}
                    {/*        </Col>*/}
                    {/*        <Col sm="4">*/}
                    {/*            <FormGroup>*/}
                    {/*                <Label className="text-capitalize">Target(s)</Label>*/}
                    {/*                <Select*/}
                    {/*                    closeMenuOnSelect={false}*/}
                    {/*                    className="dropdown"*/}
                    {/*                    placeholder="Select Target(s)"*/}
                    {/*                    value={actionPopup.managementAreaTarget}*/}
                    {/*                    options={managementAreaTargetList}*/}
                    {/*                    onChange={handleMultiSelectManagementAreaTargetChange}*/}
                    {/*                    isMulti hideSelectedOptions={false}*/}
                    {/*                    isClearable*/}
                    {/*                    components={{*/}
                    {/*                        Option*/}
                    {/*                    }}*/}
                    {/*                />*/}
                    {/*            </FormGroup>*/}
                    {/*        </Col>*/}
                    {/*    </Row>*/}
                    {/*    <Row>*/}
                    {/*        <Col sm="3">*/}
                    {/*            <span className="smart-list" style={{ fontSize: "14px", fontWeight: "700" }}>*/}
                    {/*                Good Management Practices*/}
                    {/*            </span>*/}
                    {/*        </Col>*/}
                    {/*        <Col sm="5">*/}
                    {/*            <FormGroup>*/}
                    {/*                <Label className="text-capitalize">Area / Category(s)</Label>*/}
                    {/*                <Select*/}
                    {/*                    closeMenuOnSelect={false}*/}
                    {/*                    className="dropdown"*/}
                    {/*                    placeholder="Select Area / Category(s)"*/}
                    {/*                    value={actionPopup.gmpCategory}*/}
                    {/*                    options={gmpCategoryList}*/}
                    {/*                    onChange={handleMultiSelectGMPCategoryChange}*/}
                    {/*                    isMulti hideSelectedOptions={false}*/}
                    {/*                    isClearable*/}
                    {/*                    components={{*/}
                    {/*                        Option*/}
                    {/*                    }}*/}
                    {/*                />*/}
                    {/*            </FormGroup>*/}
                    {/*        </Col>*/}
                    {/*        <Col sm="4">*/}
                    {/*            <FormGroup>*/}
                    {/*                <Label className="text-capitalize">GMP(s)</Label>*/}
                    {/*                <Select*/}
                    {/*                    closeMenuOnSelect={false}*/}
                    {/*                    className="dropdown"*/}
                    {/*                    placeholder="Select GMP(s)"*/}
                    {/*                    value={actionPopup.gmp}*/}
                    {/*                    options={gmpList}*/}
                    {/*                    onChange={handleMultiSelectGMPChange}*/}
                    {/*                    isMulti hideSelectedOptions={false}*/}
                    {/*                    isClearable*/}
                    {/*                    components={{*/}
                    {/*                        Option*/}
                    {/*                    }}*/}
                    {/*                />*/}
                    {/*            </FormGroup>*/}
                    {/*        </Col>*/}
                    {/*    </Row>*/}
                    {/*</>}*/}
                    <Row>
                        <Col sm="3">
                            <FormGroup>
                                <Label className="text-capitalize">Estimated Cost</Label>
                                <Input type="text" onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }} name="estimatedCost" id="estimatedCost" value={actionPopup.estimatedCost} onChange={handleInputChange} />
                            </FormGroup>
                        </Col>
                        <Col sm="9">
                            <FormGroup>
                                <Label className="text-capitalize">Financial Notes</Label>
                                <Input type="textarea" name="financialNotes" id="financialNotes" value={actionPopup.financialNotes} onChange={handleInputChange} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <div>
                        <PhotosWithoutId setImageUploadList={setImageUploadList} imageUploadList={imageUploadList} disabledMode={actionPopup.isCloseout} refId={tempId} header="Action Images" uploadType="Action">
                        </PhotosWithoutId>
                        <br />
                    </div>
                    {!actionPopup.isCloseout &&
                        <div>
                            <PhotosWithDetails formErrorList={formErrorList} setFormErrorList={setFormErrorList} evidenceRecordList={evidenceRecordList} setEvidenceRecordList={setEvidenceRecordList} disabledMode={actionPopup.isCloseout} refid={tempId} header="Action Evidence Records" uploadType="ActionEvidence" open={false} showArrow={true}>
                            </PhotosWithDetails>
                            <br />
                        </div>
                    }
                    <Row>
                        <Col></Col>
                        <Col sm="6">
                            {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                <>
                                    {
                                        tempId != 0 && !actionPopup.isCloseout &&
                                        <div>
                                            {savingAction ?
                                                <Button style={{ float: `right`, marginLeft: '10px' }} id="btnActionSave" onClick={handleActionSave}
                                                    color="success"
                                                    disabled
                                                >
                                                    <Row>
                                                        <Col sm="6">
                                                            <span>
                                                                {' '}Saving
                                                            </span>
                                                        </Col>
                                                        <Col sm="6">
                                                            <Spinner size="sm">
                                                                Saving...
                                                            </Spinner>
                                                        </Col>
                                                    </Row>
                                                </Button>
                                                :
                                                <Button style={{ float: `right`, marginLeft: '10px', display: 'none' }} id="btnActionSave" onClick={handleActionSave} color="success">
                                                    Save
                                                </Button>
                                            }
                                        </div>
                                    }
                                </>
                            }
                        </Col>
                    </Row>
                    {
                        tempId != 0 && <div>
                            <Row style={{ marginTop: `15px` }} xs="2">
                                <Col>
                                    <Label className="label" style={{ fontSize: `20px` }} for="significantspecies"><b><u>Action Closeout</u></b></Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="3">
                                    <FormGroup>
                                        <Label className="text-capitalize">Submit Date</Label>
                                        <DatePicker showYearDropdown yearDropdownItemNumber={15} style={{ width: `100%` }} selected={submitDate} onChange={(date) => handleSetSubmitDate(date)}
                                            name="submitDate" dateFormat="dd/MM/yyyy" className="form-control" />
                                    </FormGroup>
                                    {formErrors.submitDate != undefined &&
                                        <p className="errorMessage">{formErrors.submitDate}</p>
                                    }
                                </Col>
                                {
                                    showPastTargetOutlineReasons &&
                                    <Col sm="9">
                                        <FormGroup>
                                            <Label className="text-capitalize">If Past Target Date Outline Reasons Why?</Label>
                                            <Input type="textarea" name="pastTargetOutlineReasons" id="pastTargetOutlineReasons" onChange={handleInputChange} value={actionPopup.pastTargetOutlineReasons} />
                                        </FormGroup>
                                    </Col>
                                }
                            </Row>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label className="text-capitalize">Closeout Detail</Label>
                                        <Input type="textarea" name="closeOutDetail" id="closeOutDetail" onChange={handleInputChange} value={actionPopup.closeOutDetail} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="3">
                                    <FormGroup>
                                        <Label className="text-capitalize">Actual Cost</Label>
                                        <Input type="text" onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }} name="actualCost" id="actualCost" value={actionPopup.actualCost} onChange={handleInputChange} />
                                    </FormGroup>
                                </Col>
                                <Col sm="9">
                                    <FormGroup>
                                        <Label className="text-capitalize">Actual Cost Notes</Label>
                                        <Input type="textarea" name="actualCostNotes" id="actualCostNotes" value={actionPopup.actualCostNotes} onChange={handleInputChange} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div>
                                <Photos disabledMode={actionPopup.isCloseout} refId={tempId} header="Action Closeout Images" uploadType="ActionCloseout">
                                </Photos>
                                <br />
                            </div>
                        </div>
                    }
                </ModalBody>
                <ModalFooter>
                    {/*Intial save*/}
                    {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                        <>
                            {
                                tempId == 0 && !actionPopup.isCloseout &&
                                <div>
                                    {savingAction ?
                                        <Button style={{ float: `right`, marginLeft: '10px' }} id="btnActionSave" onClick={handleActionSave}
                                            color="success"
                                            disabled
                                        >
                                            <Row>
                                                <Col sm="6">
                                                    <span>
                                                        {' '}Saving
                                                    </span>
                                                </Col>
                                                <Col sm="6">
                                                    <Spinner size="sm">
                                                        Saving...
                                                    </Spinner>
                                                </Col>
                                            </Row>
                                        </Button>
                                        :
                                        <Button style={{ float: `right`, marginLeft: '10px' }} id="btnActionSave" onClick={handleActionSave} color="success">
                                            {actionPopup.totalActions <= 1 ? "Save" : "Save and Next Action (" + actionPopup.currentAction + " of " + actionPopup.totalActions + ")"}
                                        </Button>
                                    }
                                </div>
                            }
                        </>
                    }
                    {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                        <>
                            {
                                tempId != 0 && !actionPopup.isCloseout &&
                                <div>
                                    {savingActionCloseSave ?
                                        <Button style={{ float: `right`, marginLeft: '10px' }} id="btnActionCloseSave" onClick={handleActionCloseSave} color="success" disabled>
                                            <Row>
                                                <Col sm="6">
                                                    <span>
                                                        {' '}Saving
                                                    </span>
                                                </Col>
                                                <Col sm="6">
                                                    <Spinner size="sm">
                                                        Saving...
                                                    </Spinner>
                                                </Col>
                                            </Row>
                                        </Button>
                                        :
                                        <Button style={{ float: `right`, marginLeft: '10px', display: 'none' }} id="btnActionCloseSave" onClick={handleActionCloseSave} color="success">
                                            Save & Close Action
                                        </Button>
                                    }
                                </div>
                            }
                        </>
                    }
                    {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                        <>
                            {
                                tempId != 0 && !actionPopup.isCloseout && (!isFarmOperational || (isFarmOperational && moment(actionPopup.createdDate).format("DD/MM/YYYY") == moment().format("DD/MM/YYYY"))) &&
                                <Button style={{ float: `right`, marginLeft: '10px' }} onClick={(actionId) => handleActionDeleteClick(actionPopup.id)} color="danger" >Delete</Button>
                            }
                        </>
                    }
                    {
                        actionPopup.totalActions == 0 &&
                        <Button style={{ float: `right`, marginLeft: '10px' }} onClick={handleActionClose} color="primary" >Cancel</Button>
                    }
                    {
                        actionPopup.totalActions != 0 &&
                        <Button style={{ float: `right`, marginLeft: '10px' }} onClick={handleActionCloseWrapper} color="primary" >Cancel</Button>
                    }
                </ModalFooter>
            </Modal>

            <Modal isOpen={uploadReqPopup.showUploadReqPopup}>
                <ModalHeader toggle={handleUploadReqPopupNoClose} >Add Record</ModalHeader>
                <ModalBody>
                    Do you want to upload Photos ?
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleUploadReqPopupYesClose}>Yes</Button>
                    <Button color="danger" onClick={handleUploadReqPopupNoClose}>No</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={actionDeletePopup.showActionDeletePopup}>
                <ModalHeader toggle={handleActionDeletePopupClose} >Delete Action</ModalHeader>
                <ModalBody>
                    Do you want to delete this Action ?
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleActionDelete}>Yes</Button>
                    <Button color="danger" onClick={handleActionDeletePopupClose}>No</Button>
                </ModalFooter>
            </Modal> 
            {activityRiskPopup.showActivityRisk && (wholeFarmAction || ghgNutrient) &&
                <ActivityRiskFromSummary actionPopup={actionPopup} farmAPTActionList={farmAPTActionList} handleActivityRiskSelect={handleActivityRiskSelect} lmuId={lmuId} handleActivityRiskClose={handleActivityRiskClose} activityRiskModel={activityRiskModel} activityRiskPopup={activityRiskPopup} ItemAction={(wholeFarmAction || isGHGNutrient) ? false : true}></ActivityRiskFromSummary>
            }
        </div>
    );
}
export default ActionFromSummary;